import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
export const GroupLoadingSkeleton = () => {
  return /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    height: "20px",
    width: "58px"
  }));
};
//# sourceMappingURL=group-loading-skeleton.js.map